import { render, staticRenderFns } from "./payqrcode.vue?vue&type=template&id=6a1279b6&scoped=true"
import script from "./payqrcode.vue?vue&type=script&lang=js"
export * from "./payqrcode.vue?vue&type=script&lang=js"
import style0 from "./payqrcode.vue?vue&type=style&index=0&id=6a1279b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1279b6",
  null
  
)

export default component.exports